<template>
    <div>
            <!-- <v-expansion-panels> -->
                <!-- v-expansion-panel -->
                <div class="list-item" v-for="(item) in treeData" :key="item.id">
                    <!-- <v-expansion-panel-header class="item-name">
                       {{item.name}}
                    </v-expansion-panel-header> -->
                    <!-- <v-expansion-panel-content> -->
                    <div class="item">
                        <v-list-item  :value="item.id">
                            <template v-slot:default="{active}">
                                <v-checkbox :input-value="active"  color="primary"></v-checkbox>
                            </template>
                        </v-list-item>
                        <div class="text">
                            <v-icon v-if="item.file">{{files[item.file]}}</v-icon>
                            <v-icon v-else>mdi-folder</v-icon>
                            <span class="name tit_overflow">{{item.name}}</span>
                            <span class="name marl10 marr10">{{item.docNumber}}</span>
                            <v-icon @click="editFolder(item)">mdi-pencil</v-icon>
                            <v-icon v-if="!dialogTag" @click="addFolder(item)">mdi-plus-box-outline</v-icon>
                            <v-icon v-if="!dialogTag" @click="delFolders(item)">mdi-delete</v-icon>
                        </div>
                    </div>
                    <div v-if="item.children" class="children-item">
                        <foldTree :treeData="item.children" :dialogTag="dialogTag"></foldTree>
                    </div>
                    <!-- </v-expansion-panel-content> -->
                </div>
            <!-- </v-expansion-panels> -->
            <v-dialog v-model="addVisible" width="500">
                <v-card>
                <v-card-title class="lighten-2">{{visibleTit}}</v-card-title>

                <v-card-text>
                <v-form>
                    <v-container>
                    <v-row>
                        <v-col
                        cols="12"
                        >
                        <div class="h36">
                            <v-text-field
                                v-model="form.name"
                                label="名称"
                                required
                                outlined
                                :dense="true"
                                placeholder="请输入名称"
                            ></v-text-field>
                        </div>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col
                        cols="12"
                        >
                        <div class="h36">
                            <v-text-field
                                v-model="form.description"
                                label="描述"
                                required
                                outlined
                                :dense="true"
                                placeholder="请输入描述"
                            ></v-text-field>
                        </div>
                        </v-col>
                    </v-row>
                    </v-container>
                </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    @click="handleAddCancel">
                    取消
                </v-btn>
                <v-btn
                    color="primary"
                    @click="handleAddOk"
                    v-if="visibleTit =='新建文件夹'"
                >
                    确定
                </v-btn>
                <v-btn
                    color="primary"
                    @click="handleEditOk"
                    v-if="visibleTit =='修改文件夹'"
                >
                    确定
                </v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>
    </div>
</template>
<script>
import {mapActions} from 'vuex'
import Qs from 'qs'
export default {
    name: "foldTree",
    props: {
        treeData: Array,
        spaceId: Number,
        dialogTag: Boolean,
        isAdd: Boolean
    },
    data() {
        return {
            // id: '',
            files: {
                html: 'mdi-language-html5',
                js: 'mdi-nodejs',
                json: 'mdi-code-json',
                md: 'mdi-language-markdown',
                pdf: 'mdi-file-pdf',
                png: 'mdi-file-image',
                txt: 'mdi-file-document-outline',
                xls: 'mdi-file-excel',
            },
            addVisible: false,
            form: {},
            visibleTit: '新建文件夹',
            info: {}
        }
    },
    created() {
        this.id = this.$route.query.spaceId || this.spaceId
    },
    computed: {
        isAddFold() {
            return this.isAdd
        }
    },
    watch: {
        isAddFold(val) {
            this.addVisible = val
        }
    },
    methods: {
        ...mapActions('folder',['folderList','newFolderChild','delFolder','newFolder','newFolder1','editFolder']),
        successMsg(msg) {
            this.$message({
                type: 'success',
                message: msg || '操作成功!'
            })
        },
        failMsg(msg) {
            this.$message({
                type: 'error',
                message: msg || '操作失败!'
            })
        },
        warnMsg(msg) {
            this.$message({
                type: 'warning',
                message: msg
            })
        },
        editFolder(val) {
            this.addVisible = true
            this.visibleTit = '修改文件夹'
            this.form = val
        },
        addFolder(val){
            this.addVisible = true
            this.visibleTit = '新建文件夹'
            this.form = {},
            this.info = val
        },
        delFolders(val) {
            let data = {
                params: {
                    id: val.id
                }
            }
            let _this = this
            this.delFolder({data: data,handle(res) {
                if(res.success) {
                    _this.successMsg(res.message)
                    _this.$store.commit('setFolderUpdate','update')
                }else {
                    _this.failMsg(res.message)
                }
            }})
        },
        handleAddCancel() {
            this.addVisible = false
        },
        handleAddOk() {
            this.form.workspaceId = this.id
            this.form.parentFolderId = this.info.id
            let data = Qs.stringify(this.form)
            let _this = this
            this.newFolder1({data: data,handle(res) {
                _this.addVisible = false
                if(res.success) {
                    _this.successMsg(res.message)
                    _this.$store.commit('setFolderUpdate','update')
                }else {
                   _this.failMsg(res.message) 
                }
            }})
        },
        handleEditOk() {
            // this.addVisible = false
            let data = {
                params: {
                    folderId: this.form.id,
                    name: this.form.name,
                    description: this.form1.description
                }
            }
            let _this = this
            this.editFolder({data: data,handle(res) {
                 _this.addVisible = false
                if(res.success) {
                    _this.successMsg(res.message)
                    _this.$emit('getData', true)
                }else {
                   _this.failMsg(res.message) 
                }
            }})
        }
    }
}
</script>